// extracted by mini-css-extract-plugin
var _1 = "errors-module__buttonContainer___BGq9U";
var _2 = "errors-module__container___IPwID";
var _3 = "errors-module__contentContainer___nZVvY";
var _4 = "errors-module__error___aagHY";
var _5 = "errors-module__fullPage___aXZfT";
var _6 = "errors-module__header___CHqnd";
var _7 = "errors-module__text___vR10G";
var _8 = "errors-module__textContainer___H_QWD";
export { _1 as "buttonContainer", _2 as "container", _3 as "contentContainer", _4 as "error", _5 as "fullPage", _6 as "header", _7 as "text", _8 as "textContainer" }
